<div class="v4-filter-list py-[30px]">
  <div class="v4-filter-item">
    <host-select
      class="v4-filter-style"
      [placeholder]="'placeholder.choose_date_required' | translate"
      [listOfOption]="listOfMonthOption"
      [(ngModel)]="month"
      (ngModelChange)="onMonthChange($event)"
    ></host-select>
  </div>
</div>

<ng-container *ngIf="id">
  <host-hostex-status class="status-container" [houseTypeId]="id" [showHeader]="false"></host-hostex-status>
</ng-container>
